module.exports = "<button class=\"btn btn-outline-danger btn-round\" (click)=\"open()\">Video</button>\n    "